import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Table from "../../core/pagination/datatable";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import CommonFooter from "../../core/common/footer/commonFooter";
// import { useSelector } from "react-redux";
import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import { DatePicker } from "antd";
import dayjs from "dayjs";
// import Select from "react-select";
import Calendar from "feather-icons-react/build/IconComponents/Calendar";
import {
  fetchExpiredProducts,
  updateProductById,
  deleteProductById,
} from "../../api/expireApi.js"; // Adjust the import path as necessary
import { toast } from "react-toastify";

// ---- S3 image helpers (match Biller) ----
const normalizeKey = (s) => {
  if (!s) return "";
  let v = String(s).trim();

  // strip leading slashes
  v = v.replace(/^\/+/, "");

  // fix common misspelling
  v = v.replace(/^catelog\//i, "catalog/");

  // if it's not already catalog/, keep only the file name and prefix
  if (!/^catalog\//i.test(v)) {
    v = `catalog/${v.split("/").pop()}`;
  }
  return v;
};

const toPublicUrl = (v) => {
  if (!v) return "";
  // already a full URL
  if (/^https?:\/\//i.test(v)) return v;

  const key = normalizeKey(v);
  const base = (
    process.env.REACT_APP_API_IMAGE_BASE_URL ||
    "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com"
  ).replace(/\/+$/, "");
  return `${base}/${key}`;
};

const DEFAULT_PRODUCT_IMAGE = "/assets/img/by-default.png";

const pickImageValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value === "object") {
    return (
      value.url ||
      value.path ||
      value.key ||
      value.image ||
      value.src ||
      ""
    );
  }
  return "";
};

const resolveProductImage = (item = {}) => {
  const images = item.images;
  const raw =
    (Array.isArray(images) ? pickImageValue(images[0]) : pickImageValue(images)) ||
    pickImageValue(item.image) ||
    pickImageValue(item.productImage) ||
    pickImageValue(item.Product_Image) ||
    pickImageValue(item.thumbnail);

  return raw ? toPublicUrl(raw) : DEFAULT_PRODUCT_IMAGE;
};

const ExpiredProduct = () => {
  const [expiredData, setExpiredData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [formSku, setFormSku] = useState("");
  const [formProductName, setFormProductName] = useState(null); // for react-select
  const [manufacturedDate, setManufacturedDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [loadingExpired, setLoadingExpired] = useState(true);

  useEffect(() => {
    const loadExpiredProducts = async () => {
      try {
        setLoadingExpired(true);
        const data = await fetchExpiredProducts();
        console.log("🚀 Raw expired product API response:", data); // ADD THIS

        const formatted = data.map((item) => {
          const imgUrl = resolveProductImage(item);
          console.log("Image resolved:", imgUrl);

          return {
            key: item._id || item.id,
            _id: item._id || item.id,
            sku: item.SKU,
            product: item.productName || "Unnamed",
            img: imgUrl,
            manufactureddateFormatted: item.manufacturedDate
              ? dayjs(item.manufacturedDate).format("YYYY-MM-DD")
              : "-",
            expireddateFormatted: item.expiryDate
              ? dayjs(item.expiryDate).format("YYYY-MM-DD")
              : "-",

            // ✅ Keep raw ISO date for editing
            manufactureddate: item.manufacturedDate || null,
            expireddate: item.expiryDate || null,
          };
        });

        setExpiredData(formatted);
      } catch (error) {
        console.error("Failed to load expired products:", error);
        toast.error(`${window.translate("Failed to load expired products")}`);
      } finally {
        setLoadingExpired(false); // 👈 stop loading in all cases
      }
    };

    loadExpiredProducts();
  }, []);

  const handleEdit = (productId) => {
    console.log("Editing product:", productId);
    setSelectedProductId(productId);

    const product = expiredData.find((item) => item._id === productId);

    if (!product) {
      toast.warn("Product not found for editing.");
      return;
    }

    setFormSku(product.sku || "");
    setFormProductName(product.product || "");
    setManufacturedDate(
      product.manufactureddate ? dayjs(product.manufactureddate) : null
    );
    setExpiryDate(product.expireddate ? dayjs(product.expireddate) : null);
  };

  const handleSave = async () => {
    if (!selectedProductId) {
      toast.error(`${window.translate("No product selected to update")}`);
      return;
    }

    if (!formSku || !formProductName || !manufacturedDate || !expiryDate) {
      toast.warn("Please fill all required fields.");
      return;
    }

    const payload = {
      sku: formSku,
      productName: {
        en: formProductName, // assuming you're using English input
        ar: formProductName, // or add Arabic field separately
      },
      manufacturedDate: manufacturedDate.toDate?.() || manufacturedDate,
      expiryDate: expiryDate.toDate?.() || expiryDate,
    };

    try {
      const result = await updateProductById(selectedProductId, payload);
      // toast.success("Product updated successfully.");
      toast.success(` ${window.translate("Product updated successfully.")}`);
      setTimeout(() => {
        window.location.reload();
      }, 800);
      return result; // Return the result if needed
    } catch (error) {
      // Optionally reload expired list
      console.error("Failed to update product:", error);
      toast.error(`${window.translate("Update failed")}`);
    }
  };

  const handleDelete = (productId) => {
    setDeleteId(productId); // Set the ID when delete icon is clicked
  };

  const confirmDelete = async () => {
    try {
      setLoadingExpired(true);
      await deleteProductById(deleteId);
      // toast.success("Product deleted and archived to Out of Stock.");

      const updated = await fetchExpiredProducts();
      const formatted = updated.map((item) => {
        const imgUrl = resolveProductImage(item);
        return {
          key: item._id || item.id,
          _id: item._id || item.id,
          sku: item.sku,
          product: item.productName,
          img: imgUrl,
          manufactureddateFormatted: item.manufacturedDate
            ? dayjs(item.manufacturedDate).format("YYYY-MM-DD")
            : "-",
          expireddateFormatted: item.expiryDate
            ? dayjs(item.expiryDate).format("YYYY-MM-DD")
            : "-",

          manufactureddate: item.manufacturedDate || null,
          expireddate: item.expiryDate || null,
        };
      });

      setExpiredData(formatted);
      setDeleteId(null);
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      console.error("Failed to delete product:", error);
      toast.error(`${window.translate("Delete failed")}`);
    } finally {
      setLoadingExpired(false); // 👈 stop loading
    }
  };

  const columns = [
    {
      title: window.translate("SKU"),
      dataIndex: "sku",
      sorter: (a, b) => a.sku.length - b.sku.length,
    },
    {
      title: window.translate("Product"),
      dataIndex: "product",
      render: (text, record) => (
        <span className="productimgname">
          <Link to="#" className="product-img stock-img">
            <img
              src={record.img || DEFAULT_PRODUCT_IMAGE}
              alt="Product"
              style={{
                width: "30px",
                height: "30px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = DEFAULT_PRODUCT_IMAGE;
                console.warn("🚨 Failed to load image:", record.img);
              }}
            />
          </Link>
          {text}
        </span>
      ),
      sorter: (a, b) => a.product.length - b.product.length,
      width: "5%",
    },
    {
      title: `${window.translate("Manufacture Date")}`,
      dataIndex: "manufactureddateFormatted",
    },
    {
      title: `${window.translate("Expiry Date")}`,
      dataIndex: "expireddateFormatted",
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              className="me-2 p-2"
              to="#"
              onClick={() => handleEdit(record._id)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              className="p-2"
              onClick={() => handleDelete(record._id)}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 32, color: "#FE9F43" }} spin />
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Expired Products")}</h4>
                <h6>{window.translate("Manage your expired products")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
          </div>
          <>
            {/* /product list */}
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="dropdown me-2">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                      data-bs-toggle="dropdown"
                    >
                      Product
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Lenovo IdeaPad 3
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Beats Pro{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Nike Jordan
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Apple Series 5 Watch
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                      data-bs-toggle="dropdown"
                    >
                      Sort By : Last 7 Days
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Recently Added
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Ascending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Desending
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last Month
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="dropdown-item rounded-1">
                          Last 7 Days
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  {loadingExpired ? (
                    // 🔶 Centered orange spinner while loading
                    <div
                      style={{
                        minHeight: 150,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spin
                        indicator={antIcon}
                        tip={window.translate("Loading expired products...")}
                      />
                    </div>
                  ) : expiredData.length > 0 ? (
                    <Table
                      columns={columns}
                      dataSource={expiredData}
                      rowKey="key"
                    />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <p className="mb-0 text-muted fw-medium text-center">
                        {window.translate("No expired products found")}.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* /product list */}
          </>
        </div>
        <CommonFooter />
      </div>

      {/* edit */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header">
                  <div className="page-title">
                    <h4>{window.translate("Edit Expired Product")}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">
                            {window.translate("SKU")}
                            <span className="text-danger ms-1">*</span>
                          </label>
                          {/* <input type="text" className="form-control" /> */}
                          <input
                            type="text"
                            className="form-control"
                            value={formSku}
                            onChange={(e) => setFormSku(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label className="form-label">
                            {window.translate("Product Name")}
                            <span className="text-danger ms-1">*</span>
                          </label>
                          {/* <Select
                            classNamePrefix="react-select"
                            options={ProductName}
                            placeholder="Choose"
                          /> */}
                          <input
                            type="text"
                            className="form-control"
                            value={formProductName}
                            onChange={(e) => setFormProductName(e.target.value)}
                            placeholder="Enter product name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label>
                            {window.translate("Manufacture Date")}
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <div className="input-groupicon calender-input">
                            {/* <DatePicker
                              className="form-control datetimepicker"
                              placeholder="dd/mm/yyyy"
                            /> */}
                            <DatePicker
                              className="form-control datetimepicker"
                              placeholder="dd/mm/yyyy"
                              style={{ paddingRight: "35px" }}
                              value={manufacturedDate}
                              onChange={(date) => setManufacturedDate(date)}
                            />
                            <Calendar className="info-img" />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="mb-3">
                          <label>
                            {window.translate("Expiry Date")}
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <div className="input-groupicon calender-input">
                            {/* <DatePicker
                              className="form-control datetimepicker"
                              placeholder="dd/mm/yyyy"
                            /> */}
                            <DatePicker
                              className="form-control datetimepicker"
                              placeholder="dd/mm/yyyy"
                              style={{ paddingRight: "35px" }}
                              value={expiryDate}
                              onChange={(date) => setExpiryDate(date)}
                            />
                            <Calendar className="info-img" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleSave}
                  >
                    {window.translate("Save Changes")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CommonDeleteModal
        onConfirm={confirmDelete}
        onCancel={() => setDeleteId(null)}
        title={window.translate("Delete Expired Product")}
      />
    </div>
  );
};

export default ExpiredProduct;

